<template>
  <div class="stock-kdj-view">
    <StockKDJ />
  </div>
</template>

<script>
import StockKDJ from '@/components/indicators/StockKDJ.vue'

export default {
  name: 'StockKDJView',
  components: {
    StockKDJ
  }
}
</script>

<style scoped>
.stock-kdj-view {
  padding: 20px;
  flex: 1;
}
</style>
